import { render, staticRenderFns } from "./barcode-input-modal.vue?vue&type=template&id=5bdca15c&scoped=true"
import script from "./barcode-input-modal.vue?vue&type=script&lang=js"
export * from "./barcode-input-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdca15c",
  null
  
)

export default component.exports